import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RcFile } from 'antd/es/upload';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import { stockPartAttachmentsFilterSelector, stockPartAttachmentsSelector } from '../../../../../../store/selectors/stockSelectors';
import {
  createPartAttachmentThunk,
  deleteMultiplePartAttachmentThunk,
  getPartAttachmentsThunk,
} from '../../../../../../store/thunks/stock/part/partAttachmentsThunks';
import { setLoading } from '../../../../../../store/slices/coreSlice';
import { guidGenerator } from '../../../../../../core/utils/guidGenerator';
import CreateAttachmentModal from '../../../../../../common/components/create-attachment/CreateAttachmentModal';
import ConfirmationModal from '../../../../../../core/components/confirmation-modal/ConfirmationModal';
import PartAttachmentFilter from './filter/PartAttachmentFilter';
import PartAttachmentTable from './table/PartAttachmentTable';
import { useSelectAll } from '../../../../../../core/hooks/useSelectAll';

const PartViewAttachments = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { items, allItemIds, totalCount } = useAppSelector(stockPartAttachmentsSelector);
  const filters = useAppSelector(stockPartAttachmentsFilterSelector);

  const [isCreateModal, setCreateModal] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [fileList, setFileList] = useState<RcFile[]>([]);
  const [comment, setComment] = useState('');

  const {
    isAll,
    isIndeterminate,
    checkedKeys,
    checkAllHandle,
    checkRowHandle,
  } = useSelectAll(allItemIds);

  const cancelHandle = () => {
    setCreateModal(false);
    setFileList([]);
    setComment('');
  };

  useEffect(() => {
    id && dispatch(getPartAttachmentsThunk({ partId: +id, filters }));
    // eslint-disable-next-line
  }, [id, filters]);

  const uploadHandle = async () => {
    dispatch(setLoading(true));
    const list = fileList.map((el) => ({
      fileName: el.name,
      uploadGuid: guidGenerator(),
      file: el,
    }));
    id && dispatch(createPartAttachmentThunk({
      id: +id,
      list,
      comment: comment.trim(),
      onCancel: () => cancelHandle(),
    }));
  };

  const deleteSelected = () => {
    id && dispatch(deleteMultiplePartAttachmentThunk({
      ids: checkedKeys,
      partId: +id,
      closeModal: () => setDeleteModal(false),
    }));
  };

  return (
    <>
      <CreateAttachmentModal
        isVisible={isCreateModal}
        onCancel={cancelHandle}
        fileList={fileList}
        comment={comment}
        setComment={setComment}
        setFileList={setFileList}
        uploadHandle={uploadHandle}
      />
      <ConfirmationModal
        isVisible={isDeleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        confirmHandler={deleteSelected}
      />
      <div className="partViewAttachments">
        <PartAttachmentFilter
          filters={filters}
          totalItems={totalCount}
          setCreateModal={setCreateModal}
          setDeleteModal={() => setDeleteModal(true)}
          checkedKeys={checkedKeys}
        />
        <PartAttachmentTable
          attachments={items}
          checkedKeys={checkedKeys}
          isAll={isAll}
          indeterminate={isIndeterminate}
          checkAllHandle={checkAllHandle}
          checkRow={checkRowHandle}
        />
      </div>
    </>
  );
};

export default PartViewAttachments;
